
export interface CommentView {
    id: number;
    commentDate: Date;
    userId?: number;
    userName: string;
    userPictureUrl?: string;
    text: string;
    fromMobile?: boolean;
}
export interface CommentAdd {
    userId?: number;
    userName: string;
    text: string;
    fromMobile: boolean;
    contentObjectId?: number;
}

export interface CommentEdit {
    id: number;
    text: string;
    changedBy: number;
}

export function isCommentAdd(comment: CommentAdd | CommentEdit): comment is CommentAdd {
    return (comment as CommentAdd).userName !== undefined;
}

export function isCommentEdit(comment: CommentAdd | CommentEdit): comment is CommentEdit {
    return (comment as CommentEdit).id !== undefined;
}

export interface CommentsState {
    comments: CommentView[];
}
